export default "__VITE_ASSET__oRZiCkDO__"